class IndexMainSearch extends HTMLElement {
    constructor() {
        super();
        
        this.loadingClass = "loading";
        this.searchedClass = "searched";
        this.closingClass = "closing";
      

        this.selectors = {
            productItem: '.js-index-search-result-item',
            loading: `.${this.loadingClass}`,
            defaultLinks: '.js-default-links-container',
            defaultProducts: '.js-default-products-container'
        }

        this.form = this.querySelector('form');
        this.container = this.querySelector('.js-index-search-container');
        this.contentContainer = this.querySelector('.js-index-search-content-container');
        this.disclaimerContainer = this.querySelector('.js-index-search-content-disclaimer-container');
        this.searchInput = this.form.querySelector('.js-index-search-input')
        this.submitForm = this.form.querySelector('[type="submit"]');
        this.closeButton = this.querySelector('.js-index-search-close-icon')
        this.collectionResultsContainer = this.querySelector('.js-index-search-quick-links');
        this.collectionResultsWrapper = this.querySelector('.js-index-search-quick-links-container');
        this.productResultsContainer = this.querySelector('.js-index-search-results-container')
        this.resultsTitle = this.querySelector('.js-index-search-result-header');
        this.defaultLinks = this.querySelector(this.selectors.defaultLinks)?.innerHTML || "";
        this.defaultProducts = this.querySelector(this.selectors.defaultProducts)?.innerHTML || "";
        this.defaultTitle = this.resultsTitle.innerHTML;

        this.currentSearch;
        this.currentSearchId;

        this.init();
    }

    init() {
        console.log('init search');

        this.cleanOldSearchCache();

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.searchInput.addEventListener('keydown', this.handleInputChange.bind(this));
        this.closeButton.addEventListener('click', this.handleClose.bind(this));

        // Check URL for initial search param
        const urlParams = new URLSearchParams(window.location.search);
        const initialQuery = urlParams.get('search');
        if (initialQuery) {
            this.restoreSearchFromHistory(initialQuery)
        }

        // Listen for back/forward navigation
        window.addEventListener('popstate', (event) => {
            if (event.state?.query) {
                this.restoreSearchFromHistory(event.state.query)
            } else {
                this.resetSearchUI();
            }
        });

        //add event tracking to the product
        this.productResultsContainer.addEventListener('click', this.handleQVClick.bind(this));

        //hide and show intercom
        this.handleIntercom();
    }

    handleQVClick(event){
      const qvTrigger = event.target.closest('.js-open-qv');
      if (qvTrigger) {
        this.handleProductView(qvTrigger);
        // your logic here
      }
    }

    handleProductView(element){
      const handle = element.dataset.handle;
      const aiSearchId = element.dataset.aiSearchId;
      const interactionType = "isViewed";
      
      const params = new URLSearchParams({
          handle: handle,
          searchId: aiSearchId,
          type: interactionType
      }).toString();
      
      fetch(`${window.theme.apiUrl}/api/ai/search/productInteraction`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({
            handle,
            searchId: aiSearchId,
            type: interactionType
          })
        })
        .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }
            return response.json();
        })
        .then((response) => {
            console.log(response);
        })
    }

    handleIntercom(){
    
      // Prevent creating multiple observers
      if (this._intercomObserver) return;
    
      const observerTarget = this;
    
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            // Hide Intercom when the search container is visible
            window.Intercom?.('update', { hide_default_launcher: true });
            //console.log('intersect')
          } else {
            // Show it again when it's not
            window.Intercom?.('update', { hide_default_launcher: false });
            //console.log('not intersect')
          }
        },
        {
          root: null,
          threshold: 0.4 // Adjust as needed (20% visible = considered on screen)
        }
      );
    
      observer.observe(observerTarget);
    
      this._intercomObserver = observer;
    }

    handleClose(){
      // Clear the URL parameter
      const url = new URL(window.location.href);
      url.searchParams.delete('search');
      history.pushState({}, '', url.toString());
      
      //remove products and collections
      this.productResultsContainer.innerHTML = "";
      this.collectionResultsContainer.innerHTML = "";
  
      // Clear input value
      this.searchInput.value = '';

      //reset min height
      this.container.style.minHeight = "auto";

      this.classList.add(this.closingClass);

      this.classList.remove(this.searchedClass);

      // Remove 'searched' class
      setTimeout(function(){
        
        this.classList.remove(this.closingClass);
      }.bind(this), 1000)
      

      
    }

    handleInputChange(event) {
        
        /*
        switch (event.code) {
            case 'Enter':
                event.preventDefault();
                this.handleSubmit(event);
                break;
        }*/

       // For textarea, intercept only plain Enter (not Shift+Enter)
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.handleSubmit(event);
        }      
    }

    handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!this.form.checkValidity()) {
            this.form.reportValidity(); // shows native validation message
            return;
        }

        const query = this.searchInput.value

        

        console.log('search', query);

        // Scroll results into view
        this.scrollResultsIntoView();

        
        //init search elements
        this.startSearch();
        this.search(query);

        // Push to history and update URL
        const url = new URL(window.location.href);
        url.searchParams.set('search', query);
        history.pushState({ query }, '', url.toString());

        // Pre-cache with empty data
        localStorage.setItem(`search:${query}`, JSON.stringify({
            timestamp: Date.now(),
            data: null
        }));
    }

    startSearch() {

        this.disableInputs();


        //add searched class
        this.classList.add(this.searchedClass);

        //clear product results
        this.productResultsContainer.innerHTML = '';

        this.resultsTitle.innerHTML = this.defaultTitle;
    }

    disableInputs() {
        this.searchInput.disabled = true;
        this.submitForm.disabled = true;
    }

    enableInputs() {
        this.searchInput.disabled = false;
        this.submitForm.disabled = false;
    }

    search(query) {

        //add loading class
        this.classList.add(this.loadingClass);

        const locale = window.theme.apiLocale || 'us';
        const params = new URLSearchParams({
            search: query,
            locale: locale.toLowerCase()
        }).toString();
        
        fetch(`${window.theme.apiUrl}/api/ai/search?${params}`, {
            credentials: 'include'
        })
        .then((response) => {
            console.log('res', response);
            //alert(response)
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }
            console.log('res ok');
            return response.json();
        })
        .then((response) => {
            console.log(response);
            const { products, search } = response;

            // Cache in localStorage
            const cached = localStorage.getItem(`search:${query}`);
            if (cached) {
                const parsed = JSON.parse(cached);
                parsed.data = response;
                localStorage.setItem(`search:${query}`, JSON.stringify(parsed));
            }

            if (search == "no results" || !products || products.length == 0) {
                this.handleNoResults();
            } else {
                this.handleSearchReturn(response);
            }
        
        })
        .catch((error) => {
            console.log(error);
            this.handleNoResults();
            if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
            }
            throw error;
        })
        .finally(() => {
            this.enableInputs();
            //remove loading class
            this.classList.remove(this.loadingClass);

            this.resizeContainer();
        });
        
        
    }

    restoreSearchFromHistory(query) {
        this.searchInput.value = query;
        this.startSearch();

        const cached = localStorage.getItem(`search:${query}`);
        if (cached) {
            const parsed = JSON.parse(cached);
            if (parsed.data) {
                setTimeout(() => {
                    this.handleSearchReturn(parsed.data);
                    this.enableInputs();
                    this.classList.remove(this.loadingClass);
                    this.resizeContainer();
                    return;
                }, 3000);
                
            }
        }

        // If not cached or no data yet, fallback to live search
        this.search(query);
    }

    resetSearchUI() {
        this.classList.remove('searched');
        this.searchInput.value = '';
        this.resultsTitle.innerHTML = this.defaultTitle;
        this.productResultsContainer.innerHTML = this.defaultProducts;
        this.collectionResultsContainer.innerHTML = this.defaultLinks;
        this.collectionResultsWrapper.classList.remove('hidden');
    }

    //delete entries older than 1 day
    cleanOldSearchCache() {
        const now = Date.now();
        const oneDay = 24 * 60 * 60 * 1000;

        for (let key in localStorage) {
            if (key.startsWith('search:')) {
            try {
                const parsed = JSON.parse(localStorage.getItem(key));
                if (parsed.timestamp && now - parsed.timestamp > oneDay) {
                localStorage.removeItem(key);
                }
            } catch (e) {
                localStorage.removeItem(key);
            }
            }
        }
    }

    handleNoResults() {
        console.log('no results')
        const noResultTitle = window.theme.strings.mainSearch.no_results || "Your search did not yield any results."
        this.handleTitleChange(noResultTitle);
        this.productResultsContainer.innerHTML = this.defaultProducts;
        //this.collectionResultsContainer.innerHTML = this.defaultLinks;

        // Explicitly pass 0 results
        this.updateLiveRegion(0, 0);
        
    }

    handleSearchReturn(data) {
        const { collections, title, products, search, searchId } = data;

        //init actual search query used;
        this.currentSearch = search;
        this.currentSearchId = searchId;

        this.handleCollectionResults(collections);
        this.handleTitleChange(title)
        this.handleProductResults(products)

        // Live region update with both counts
        const productCount = Array.isArray(products) ? products.length : 0;
        const collectionCount = Array.isArray(collections) ? collections.length : 0;
      
        this.updateLiveRegion(productCount, collectionCount);
        
        // Scroll results into view
        this.scrollResultsIntoView();
    }

    handleTitleChange(title) {
        this.resultsTitle.innerHTML = title;
    }

    handleCollectionResults(collections) {
        let results = ''

        if (collections && collections.length == 0) {
            this.collectionResultsWrapper.classList.add('hidden');
            return;
        } else {
            this.collectionResultsWrapper.classList.remove('hidden');
        }
        

        collections?.forEach((collection) => {
            const url = `/collections/${collection.handle}`
            const template = `<li class="index-search-quick-link glass-effect">
                <a target="_blank" href="${url}">${collection.title}</a>
            </li>`

            results += template;
        })

        this.collectionResultsContainer.innerHTML = results
    }

    handleProductResults(products) {
        this.clearProductResults();

        const button_text = window.theme.strings.mainSearch.button_text || "Shop Now"

        const resultsLimit = Math.min(products.length, 4);
        for (let i = 0; i < resultsLimit; i++){
            const product = products[i];
            const image = product.featuredImage?.url;
            const title = product.title;
            const url = product.onlineStoreUrl;
            const price = product.priceRangeV2?.minVariantPrice.amount;
            const f_price = slate.Currency.formatMoney(price, theme.moneyFormat);
            const handle = product.handle;
            const answer = product.answer;
            
            let template = `
                <a href="${url}" class="js-open-qv" data-handle="${handle}" data-ai-query="${this.currentSearch}" data-ai-search-id="${this.currentSearchId}">
                    <div class="index-search-result-item-image-container responsive-media-container">
                        <img height="800" width="800" src="${image}&width=800" alt="${title} product image">
                    </div>
                    <div class="index-search-result-item-content-container">
                        <h3 class="index-search-result-item-title">${title}</h3>
                        <div class="index-search-result-item-price-container">
                            <span class="price"><span class="money">${f_price}</span></span>
                        </div>
                        <span class="index-search-result-item-button btn__underline-animation reverse">${ button_text }</span>
                        ${ i == 0 ? `<span class="index-search-result-item-footer-text">${window.theme.strings.mainSearch.why_selected_text}</span>` : ""}
                    </div>
                </a>
            `

            //search for loading blocks first. If no available loading blocks then create new one
            let productContainer = this.productResultsContainer.querySelector(this.selectors.productItem + this.selectors.loading);
            if (productContainer) {
                productContainer.innerHTML = template;
                productContainer.classList.remove(this.loadingClass);
            } else {
                //add new block
                const wrapper = document.createElement('div');
                const wrapperClass = ['index-search-result-item', 'js-index-search-result-item', 'glass-effect']
                wrapper.classList.add(...wrapperClass);
                wrapper.innerHTML = template;

                this.productResultsContainer.appendChild(wrapper);
            }
        }

        //cleanProductContainer();
        
    }

    //look for blocks with loading and remove them after results has been processed
    cleanProductContainer() {
        this.querySelectorAll(this.selectors.productItem + this.selectors.loading).forEach((item) => {
            item.remove();
        })
    }

    clearProductResults() {
        this.querySelectorAll(this.selectors.productItem).forEach((item) => {
            item.innerHTML = '';
            item.classList.add(this.loadingClass);
        })
    }

    resizeContainer() {
        const contentContainerHeight = this.contentContainer.offsetHeight;
        const disclaimerContainerHeight = this.disclaimerContainer.offsetHeight;
        const spacing = 60;

        const containerHeight = contentContainerHeight + disclaimerContainerHeight + spacing;

        this.container.style.minHeight = `${containerHeight}px`;
    }


    updateLiveRegion(productsCount = 0, collectionsCount = 0) {
      const liveRegion = this.querySelector('[data-ai-search-live-region-count-value]');
      if (liveRegion) {
        let messageParts = [];
    
        if (collectionsCount > 0) {
          messageParts.push(`${collectionsCount} collection${collectionsCount !== 1 ? 's' : ''}`);
        }
    
        if (productsCount > 0) {
          messageParts.push(`${productsCount} product${productsCount !== 1 ? 's' : ''}`);
        }
    
        const message = messageParts.length
          ? `${messageParts.join(' and ')} found`
          : `No results found`;
    
        liveRegion.textContent = message;
      }
    }


    scrollResultsIntoView() {
      const container = this.container;
      if (!container) return;
    
      const rect = container.getBoundingClientRect();
    
      // Already in view (with offset)?
      const offset = 60;
      const aboveTop = rect.top - offset;
      const belowBottom = rect.bottom - (window.innerHeight || document.documentElement.clientHeight);
    
      if (aboveTop >= 0 && belowBottom <= 0) {
        // Already in view (with offset)
        return;
      }
    
      // Get the absolute scroll position for the top of the container minus offset
      const scrollTo = window.scrollY + rect.top - offset;
    
      window.scrollTo({
        top: scrollTo,
        behavior: "smooth"
      });
    }

  
}
  
customElements.define('index-main-search', IndexMainSearch);